import React from 'react';
import Type from 'prop-types';
import noop from 'lodash/noop';
import { Card, CardContent, CardActionArea, Typography } from '@material-ui/core';
import { Amount } from 'components';
import { ru } from 'locale';
import { statusesColor } from 'utils/constants';
import useStyles from './AnketaItem.styles';

const AnketaItem = props => {
  const classes = useStyles();
  const { item, onClick } = props;
  const status = item.status.toLowerCase();

  const handleClick = () => {
    onClick(item.anketId);
  };

  return (
    <Card square>
      <CardActionArea onClick={handleClick}>
        <CardContent>
          <Typography color="secondary">{item.organizationName}</Typography>
          <Typography variant="body2" color="textSecondary">
            {`${ru.amount}: `}
            <Amount
              className={classes.amount}
              amount={{ value: item.amount, currency: { code: 'RUR', minority: 0 } }}
            />
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {`${ru.postponement}: ${item.delay}`}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {`${ru.id}: ${item.anketId}`}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {`${ru.salesOrg}: ${item.salesOrganization}`}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {`${ru.status}: `}
            <span style={{ color: statusesColor[status] }}>{ru[status]}</span>
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

AnketaItem.propTypes = {
  item: Type.shape({
    organizationName: Type.string.isRequired,
    anketId: Type.string.isRequired,
    status: Type.string.isRequired,
    salesOrganization: Type.string.isRequired,
    amount: Type.number.isRequired,
    delay: Type.number.isRequired,
    contragentId: Type.string.isRequired,
  }).isRequired,
  onClick: Type.func,
};

AnketaItem.defaultProps = {
  onClick: noop,
};

export default AnketaItem;
